var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"closable":false,"btns":_vm.btns},model:{value:(_vm.activeVisible),callback:function ($$v) {_vm.activeVisible=$$v},expression:"activeVisible"}},[_vm._v(" "+_vm._s(_vm.$t('flash_pay_service'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }